import { render, staticRenderFns } from "./MainSchool.vue?vue&type=template&id=f382510e"
import script from "./MainSchool.vue?vue&type=script&lang=js"
export * from "./MainSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports